import { useState } from "react";
import { Button, message } from "antd";
import { useParams } from "react-router-dom";
import classes from "./ShareModalContent.module.css";
import { SharePrivacy } from "../SharePrivacy/SharePrivacy";
import ShareForm from "../SharePrivacy/ShareForm";
import { workwiseServices } from "../../../Workw-Api/api";
import { updateDocumentPrivacy } from "../../../utils/api";
import { useDocument } from "../../../Pages/SpreadsheetContainer/documentInfoContex";

/**
 * Share dialog body.
 *
 * Sections run in the order the decision is actually made — who you are inviting
 * (restricted only), then what the link itself grants — over a footer that holds
 * whichever action closes the dialog.
 */
export const ShareModalContent = ({ setIsModalVisible, privacy, setPrivacy, view, setView }) => {
  const { id } = useParams();
  const { documentInfo, setDocumentInfo, isExternalAllow, setIsExternalAllow } = useDocument();

  const [submitting, setSubmitting] = useState(false);
  const [publishing, setPublishing] = useState(false);
  const [removing, setRemoving] = useState(false);

  const isRestricted = privacy === 1;
  const isInviteView = view === "invite";

  const handleBack = () => {
    setPrivacy(0);
    setView("access");
  };

  const handleSelectAccess = (key) => {
    setPrivacy(key);
    if (key === 1) {
      setView("invite");
    }
  };
  const privacyId = 1;
  const payload = { attachmentId: id, name: documentInfo?.name, privacyId };

  const callShareDocumentToAnyone = async () => {
    setPublishing(true);
    try {
      await workwiseServices.shareDocumentToAnyone(payload);
      message.success("Document is shared as Public");
      setIsModalVisible(false);
      const response = await workwiseServices.getDocumentById(id);
      if (response?.status === 200 && response.data?.data?.rightType !== 0) {
        setDocumentInfo(response.data.data);
      }
      await updateDocumentPrivacy({ documentId: id, isExternal: true, name: documentInfo?.name });
      setIsExternalAllow(true);
    } catch (error) {
      console.error("Error sharing document:", error);
      message.error("Failed to share document. Please try again.");
      setPublishing(false);
    }
  };

  const handleRemoveAccess = async () => {
    setRemoving(true);
    try {
      await updateDocumentPrivacy({
        documentId: id,
        isExternal: false,
        name: documentInfo?.name
      });
      setIsExternalAllow(false);
      message.success("External access removed successfully!");
      setIsModalVisible(false);
    } catch (error) {
      console.error("Error removig document access:", error);
      const errorMessage = error.response?.data?.message || "Failed to remove access.";
      message.error(errorMessage);
      setRemoving(false);
    }
  };

  return (
    <div className={classes.modalContent}>
      {isInviteView ? (
        <section className={classes.section}>
          <ShareForm
            setIsModalVisible={setIsModalVisible}
            setPrivacy={setPrivacy}
            onBack={handleBack}
            setSubmitting={setSubmitting}
          />
        </section>
      ) : (
        <section className={classes.section}>
          <SharePrivacy privacy={privacy} setPrivacy={handleSelectAccess} />
        </section>
      )}

      {isInviteView ? (
        <footer className={classes.footer}>
          <Button
            className={classes.shareBtn}
            size="middle"
            htmlType="submit"
            form="share-invite-form"
            loading={submitting}
            disabled={submitting}
          >
            Share
          </Button>
        </footer>
      ) : (
        !isRestricted && (
          <footer className={classes.footer}>
            {isExternalAllow && (
              <Button
                className={classes.removeAccessBtn}
                size="middle"
                onClick={handleRemoveAccess}
                loading={removing}
                disabled={removing}
              >
                Remove external
              </Button>
            )}
            <Button
              className={classes.shareBtn}
              size="middle"
              onClick={callShareDocumentToAnyone}
              loading={publishing}
              disabled={isExternalAllow || publishing}
            >
              {isExternalAllow ? 'Public' : 'Make public'}
            </Button>
          </footer>
        )
      )}
    </div>
  );
};
